// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__gqRpE","header":"modal_header__BnTN7","header_text":"modal_header_text__eG4kb","content":"modal_content__Dis1W","close_icon":"modal_close_icon__WesxP"};